import { FeatureFlagName } from './feature-flags'
import { arrayToObject } from './helpers'

// WARNING! Don't put anything here that you do not want to be exposed to the client.
export const CONFIG = [
  'NEXT_PUBLIC_ASSET_HOST',
  'NEXT_PUBLIC_AU_HOST',
  'NEXT_PUBLIC_NZ_HOST',
  'NEXT_PUBLIC_CONTENT_SERVICE',
  'NEXT_PUBLIC_CONTENT_SERVICE_V2',
  'NEXT_PUBLIC_ALGOLIA_APPLICATION_ID',
  'NEXT_PUBLIC_ALGOLIA_SEARCH_KEY',
  'NEXT_PUBLIC_MKP_ALGOLIA_APPLICATION_ID',
  'NEXT_PUBLIC_MKP_ALGOLIA_SEARCH_KEY',
  'NEXT_PUBLIC_MAPS_API',
  'NEXT_PUBLIC_SCENTREGROUP_API',
  'NEXT_PUBLIC_SCENTREGROUP_API_KEY',
  'NEXT_PUBLIC_SENTRY_DSN',
  'NEXT_PUBLIC_SENTRY_ENV',
  'NEXT_PUBLIC_AUTH0_DOMAIN',
  'NEXT_PUBLIC_AUTH0_CLIENT_ID',
  'NEXT_PUBLIC_GTM_ID',
  ...Object.keys(FeatureFlagName),
]

export const CONFIG_KEYS = arrayToObject(CONFIG)

export const getClientConfigValue = configKey => {
  if (typeof window !== 'undefined' && typeof window.__ENV__ !== 'undefined') {
    // We're in the browser, and we've setup __ENV__, which only happens in the existing site,
    // not the Next.js site. We return the value set on window.__ENV__
    return window.__ENV__[configKey]
  }

  // Otherwise, if on the server (either Next.js or existing site), or in the browser, but without
  // window.__ENV__ defined (ie; in the browser with Next.js), then we return the value of process.env
  // We need a map of all the keys to their process.env values manually because Next JS
  // does a search and replace like operation to populate these values in the client side bundle.
  /* eslint-disable no-process-env */
  return {
    NEXT_PUBLIC_ASSET_HOST: process.env.NEXT_PUBLIC_ASSET_HOST,
    NEXT_PUBLIC_AU_HOST: process.env.NEXT_PUBLIC_AU_HOST,
    NEXT_PUBLIC_NZ_HOST: process.env.NEXT_PUBLIC_NZ_HOST,
    NEXT_PUBLIC_CONTENT_SERVICE: process.env.NEXT_PUBLIC_CONTENT_SERVICE,
    NEXT_PUBLIC_CONTENT_SERVICE_V2: process.env.NEXT_PUBLIC_CONTENT_SERVICE_V2,
    NEXT_PUBLIC_ALGOLIA_APPLICATION_ID:
      process.env.NEXT_PUBLIC_ALGOLIA_APPLICATION_ID,
    NEXT_PUBLIC_ALGOLIA_SEARCH_KEY: process.env.NEXT_PUBLIC_ALGOLIA_SEARCH_KEY,
    NEXT_PUBLIC_MKP_ALGOLIA_APPLICATION_ID:
      process.env.NEXT_PUBLIC_MKP_ALGOLIA_APPLICATION_ID,
    NEXT_PUBLIC_MKP_ALGOLIA_SEARCH_KEY:
      process.env.NEXT_PUBLIC_MKP_ALGOLIA_SEARCH_KEY,
    NEXT_PUBLIC_MAPS_API: process.env.NEXT_PUBLIC_MAPS_API,
    NEXT_PUBLIC_SCENTREGROUP_API: process.env.NEXT_PUBLIC_SCENTREGROUP_API,
    NEXT_PUBLIC_SCENTREGROUP_API_KEY:
      process.env.NEXT_PUBLIC_SCENTREGROUP_API_KEY,
    NEXT_PUBLIC_SENTRY_DSN: process.env.NEXT_PUBLIC_SENTRY_DSN,
    NEXT_PUBLIC_SENTRY_ENV: process.env.NEXT_PUBLIC_SENTRY_ENV,
    NEXT_PUBLIC_TOGGLE_WHATS_ON_DECK_FILTERS:
      process.env.NEXT_PUBLIC_TOGGLE_WHATS_ON_DECK_FILTERS,
    NEXT_PUBLIC_TOGGLE_WHATS_HAPPENING_SEE_MORE:
      process.env.NEXT_PUBLIC_TOGGLE_WHATS_HAPPENING_SEE_MORE,
    NEXT_PUBLIC_FEAT_FLAG_GIFT_CARD_LANDING:
      process.env.NEXT_PUBLIC_FEAT_FLAG_GIFT_CARD_LANDING,
    NEXT_PUBLIC_FEAT_FLAG_EVENT_NOTY:
      process.env.NEXT_PUBLIC_FEAT_FLAG_EVENT_NOTY,
    NEXT_PUBLIC_FEAT_FLAG_CONTENT_BLOCK:
      process.env.NEXT_PUBLIC_FEAT_FLAG_CONTENT_BLOCK,
    NEXT_PUBLIC_FEAT_FLAG_MEASUREMENT:
      process.env.NEXT_PUBLIC_FEAT_FLAG_MEASUREMENT,
    NEXT_PUBLIC_FEAT_FLAG_WEVO: process.env.NEXT_PUBLIC_FEAT_FLAG_WEVO,
    NEXT_PUBLIC_AUTH0_DOMAIN: process.env.NEXT_PUBLIC_AUTH0_DOMAIN,
    NEXT_PUBLIC_AUTH0_CLIENT_ID: process.env.NEXT_PUBLIC_AUTH0_CLIENT_ID,
    NEXT_PUBLIC_GTM_ID: process.env.NEXT_PUBLIC_GTM_ID,
  }[configKey]
  /* eslint-enable no-process-env */
}

export const getClientConfigBool = configKey =>
  ['true', true].includes(getClientConfigValue(configKey))

export const getAlgoliaApiKeys = () => ({
  contentApiKey: getClientConfigValue(
    CONFIG_KEYS.NEXT_PUBLIC_ALGOLIA_SEARCH_KEY
  ),
  contentApplicationId: getClientConfigValue(
    CONFIG_KEYS.NEXT_PUBLIC_ALGOLIA_APPLICATION_ID
  ),
  marketplaceApiKey: getClientConfigValue(
    CONFIG_KEYS.NEXT_PUBLIC_MKP_ALGOLIA_SEARCH_KEY
  ),
  marketplaceApplicationId: getClientConfigValue(
    CONFIG_KEYS.NEXT_PUBLIC_MKP_ALGOLIA_APPLICATION_ID
  ),
})

export const CONFIG_PROCESS_ENV_MAP = CONFIG.reduce((acc, key) => {
  acc[key] = process.env[key] // eslint-disable-line no-process-env

  return acc
}, {})

// In dev mode, we use http. Everywhere else, we use https
// eslint-disable-next-line no-process-env
const protocol = process.env.NODE_ENV === 'development' ? 'http' : 'https'

export const NATIONAL_CONFIG = {
  au: {
    title: 'Westfield Australia',
    meta: [
      {
        name: 'description',
        content:
          "Find thousands of products from your favourite retailers across women's and men's fashion, kids, home and decor and more.",
      },
      { name: 'keywords', content: 'sample, something' },
    ],
    country: 'Australia',
    lang: 'en-AU',
    url: `${protocol}://${getClientConfigValue(
      CONFIG_KEYS.NEXT_PUBLIC_AU_HOST
    )}`,
  },
  nz: {
    title: 'Westfield New Zealand',
    meta: [
      {
        name: 'description',
        content:
          "Find thousands of products from your favourite retailers across women's and men's fashion, kids, home and decor and more.",
      },
      { name: 'keywords', content: 'sample, something' },
    ],
    country: 'New Zealand',
    lang: 'en-NZ',
    url: `${protocol}://${getClientConfigValue(
      CONFIG_KEYS.NEXT_PUBLIC_NZ_HOST
    )}`,
  },
}
